// Centralized numeric stability configuration
// Tweak these values to control coefficient normalization and decimal precision.

export const STABILITY = {
  // Max absolute value tolerated for tableau fractions before stabilization
  tableauCoeffLimit: 1e6,

  // Global cap for cut coefficients; cuts exceeding this will be rescaled down
  cutCoeffLimit: 1_000_000,

  // Precision used when converting unstable fractions to decimals
  stableDecimalPrecision: 10,
} as const

